import React, { useState } from "react";
import { TableDateRange } from "../../common/components/TableDateRange";
import { NoRecords } from "../../common/components/NoRecords";
import { useQueryWithPagination } from "../../utils/Hooks";
import { AxiosEmployeeRecordApi } from "../Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";

const EmployeeHistoryTable = ({ records, ordering, setOrdering }) => {
  if (records.length === 0) {
    return (
      <NoRecords message={"Não existem registros para este funcionário!"} />
    );
  }
  const rows = records.map((el) => ({
    id: el.id,
    startDate: el.timespan.lower,
    endDate: el.timespan.upper,
    name: el.corporation?.name,
    branch_corporation: el.branch_corporation?.name,
    contract_type: el.contract_type?.description,
  }));

  return (
    <TableDateRange
      recordName={"Empresa"}
      data={rows}
      ordering={ordering}
      setOrdering={setOrdering}
      nameColumn="corporation"
    />
  );
};

export const EmployeeHistoryList = ({ employee_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { isPending, data, error, handleNext, handlePrevious } =
    useQueryWithPagination({
      queryKey: ["employee-history-list", employee_id, ordering],
      queryFn: AxiosEmployeeRecordApi.getForEmployee,
      employee_id: employee_id,
      ordering: ordering,
      expand: ["corporation", "branch_corporation", "contract_type"],
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <EmployeeHistoryTable
          records={data.results}
          ordering={ordering}
          setOrdering={setOrdering}
        />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
